import React from 'react'
import { Box, Button, HStack, Text } from '@chakra-ui/react'
import { AlsClinicAttendance } from '../../../../types/support'
import RatingInput from './RatingInput'

interface AlsClinicQuestionProps {
  value: AlsClinicAttendance
  onChange: (value: AlsClinicAttendance) => void
}

const AlsClinicQuestion: React.FC<AlsClinicQuestionProps> = ({
  value,
  onChange,
}) => {
  const handleAttendedChange = (attended: boolean) => {
    if (attended) {
      onChange({ attended: true, rating: value.rating })
    } else {
      onChange({ attended: false, rating: null })
    }
  }

  const handleRatingChange = (rating: 1 | 2 | 3 | 4 | 5 | null) => {
    onChange({ ...value, rating })
  }

  return (
    <Box borderWidth='1px' borderRadius='md' p={4}>
      <Text fontWeight='bold' mb={3}>
        Did you attend an ALS clinic this month?
      </Text>
      <HStack spacing={3} mb={4}>
        <Button
          size='sm'
          variant={value.attended === true ? 'solid' : 'outline'}
          colorScheme='purple'
          onClick={() => handleAttendedChange(true)}
        >
          Yes
        </Button>
        <Button
          size='sm'
          variant={value.attended === false ? 'solid' : 'outline'}
          colorScheme='purple'
          onClick={() => handleAttendedChange(false)}
        >
          No
        </Button>
      </HStack>
      {value.attended === true && (
        <Box>
          <Text mb={2}>How would you rate your clinic experience?</Text>
          <RatingInput value={value.rating} onChange={handleRatingChange} />
        </Box>
      )}
    </Box>
  )
}

export default AlsClinicQuestion
